(() => {
  // Sem pushState/popstate aqui: o router do Pipeline (theme.js, x-router)
  // recarrega a página em todo popstate com state.fromRouter, então qualquer
  // mexida no histórico ao abrir/fechar o menu vira reload. Decidido em
  // 2026-09-17: fechar pelo X, pelo fundo ou por Esc; "voltar" sai da página.

  function initBechoseMobileMenu() {
    document.querySelectorAll('[data-bechose-mobile-menu]:not([data-bechose-menu-ready])').forEach((menu) => {
      menu.setAttribute('data-bechose-menu-ready', 'true');
      const tabs = Array.from(menu.querySelectorAll('[data-bechose-menu-tab]'));
      const panels = Array.from(menu.querySelectorAll('[data-bechose-menu-panel]'));

      const loadBannerImages = (panel) => {
        panel.querySelectorAll('template[data-bechose-banner-image]').forEach((template) => {
          template.replaceWith(template.content.cloneNode(true));
        });
      };

      const activate = (name, focus = false, loadImages = true) => {
        tabs.forEach((tab) => {
          const active = tab.dataset.bechoseMenuTab === name;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
          if (active && focus) tab.focus();
        });

        panels.forEach((panel) => {
          const active = panel.dataset.bechoseMenuPanel === name;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
          if (active && loadImages) loadBannerImages(panel);
        });

        const scrollContainer = menu.closest('[data-drawer-scrolls]');
        if (scrollContainer) scrollContainer.scrollTop = 0;
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab.dataset.bechoseMenuTab));
        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
          event.preventDefault();
          const step = event.key === 'ArrowRight' ? 1 : -1;
          const next = (index + step + tabs.length) % tabs.length;
          activate(tabs[next].dataset.bechoseMenuTab, true);
        });
      });

      const defaultTab = tabs.length ? tabs[0].dataset.bechoseMenuTab : '';
      const drawer = menu.closest('[data-drawer="hamburger"]');
      if (drawer && defaultTab) drawer.addEventListener('theme:drawer:open', () => activate(defaultTab));
      if (defaultTab) activate(defaultTab, false, false);
    });
  }

  document.addEventListener('shopify:section:load', initBechoseMobileMenu);
  initBechoseMobileMenu();
})();
